// extracted by mini-css-extract-plugin
module.exports = {"content":"VI0XaBr _2wW_gNj","panel":"_1EnNGY9 _1-GK5zo"};